<!-- Header -->
<div mat-dialog-title>
	<span *ngIf="addMode">Add Student List</span>
	<span *ngIf="editMode">Edit Student List</span>
	<span *ngIf="viewMode">View Student List</span>
</div>

<!-- Body -->
<mat-dialog-content>
	<!-- Form for validation -->
	<form #form="ngForm"
		class="listEntriesBLock">

        <!-- Warning in case you aren't owner -->
        <div *ngIf="!viewMode && studentList.Owner != staffId">
            <b><span translate>You must take ownership to edit the list.</span></b>
        </div>

        <!-- Name -->
		<tyl-form-field label="Name"
			[hint]="getHint(studentList.Name, 50)">
			<input matInput
				name="Name"
				id="nameField"
				maxlength="50"
				#nameField
				[disabled]="getDisabled()"
				[required]="true"
				[(ngModel)]="studentList.Name">
		</tyl-form-field>

		<!-- Description -->
		<tyl-form-field label="Description"
			[hint]="getHint(studentList.Description, 100)">
			<textarea matInput
                style="resize: none"
				name="Description"
				id="descriptionField"
				rows="3"
				maxlength="100"
				#descriptionField
				[disabled]="getDisabled()"
				[required]="true"
				[(ngModel)]="studentList.Description"></textarea>
		</tyl-form-field>

		<!-- Type -->
		<tyl-form-field *ngIf="V10" label="Type">
			<mat-select [disabled]="getDisabled()"
				name="Type"
				id="typeField"
				[(ngModel)]="studentList.Type">
				<mat-option [value]="null"></mat-option>
				<mat-option *ngFor="let type of types"
					[value]="type.CodeDescription">
					{{type.CodeDescription}}
				</mat-option>
			</mat-select>
		</tyl-form-field>

		<!-- Scope -->
		<tyl-form-field *ngIf="V10" label="Access">
			<mat-select [disabled]="getDisabled()"
				name="Scope"
				id="scopeField"
				[(ngModel)]="studentList.Scope">
				<mat-option [value]="null"></mat-option>
				<mat-option *ngFor="let scope of scopes"
					[value]="scope.CodeDescription">
					{{scope.CodeDescription}}
				</mat-option>
			</mat-select>
		</tyl-form-field>

		<!-- Status -->
        <tyl-form-field label="Status">
            <mat-select [disabled]="getDisabled()"
                name="Status"
                id="statusField"
                [required]="true"
                [(ngModel)]="studentList.Status">
                <mat-option [value]="true">
                    Active
                </mat-option>
                <mat-option [value]="false">
                    Inactive
                </mat-option>
            </mat-select>
        </tyl-form-field>
<!--		<label>Status</label>-->
<!--		<tyl-radio-group [disabled]="viewMode"-->
<!--			style="display: block"-->
<!--			[(selected)]="studentList.Status"-->
<!--			arrange="vertical"-->
<!--			name="status"-->
<!--			[required]="true"-->
<!--			[values]="[true, false]"-->
<!--			[labels]="['Active', 'Inactive']"-->
<!--			[ids]="['statusActiveRadio', 'statusInactiveRadio']"></tyl-radio-group>-->

		<!-- Access -->
		<label>
            Scope
            <span class="redStar">*</span>
        </label>
		<tyl-radio-group [disabled]="getDisabled()"
			style="display: block"
			[(selected)]="studentList.Access"
			arrange="vertical"
			name="access"
			[required]="true"
			[values]="['Private', 'Public within School', 'Public district wide']"
			[labels]="['Private', false, 'Available to District']"
			[ids]="['accessPrivateRadio', 'accessSchoolRadio', 'accessDistrictRadio']"
            [disabledValues]="[
                allowCreateSchoolLists ? '' : 'Public within School',
                allowCreateDistrictLists ? '' : 'Public district wide'
            ]"
			[contentTemplate]="scopeRadioTemplate"></tyl-radio-group>

        <!-- Owner -->
        <label style="padding-top: 15px;">
            Owner
            <span class="redStar">*</span>
        </label>
        <div style="display: flex; align-items: center;">
            <span>{{studentList.OwnerLastName}}, {{studentList.OwnerFirstName}}</span>
            <span>&nbsp;</span>
            <button mat-stroked-button
                [disabled]="viewMode"
                (click)="selectStaff()">
                <span translate>Select Staff</span>
            </button>
        </div>
	</form>

	<!-- Students Table -->
    <div class="studentTableBlock">
        <mat-table [dataSource]="tableData"
            matSort
            matSortDisableClear
            matSortActive="name"
            matSortDirection="asc">

            <!-- Student # Column -->
            <ng-container matColumnDef="studentNumber">
                <mat-header-cell mat-sort-header="number"
                    *matHeaderCellDef
                    translate>
                    Student #
                    <filter [data]="tableData"
                        columnName="number"
                        dataType="number"
                        id="studentNumberFilter"
                        class="mat-filter"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let student">
                    {{student.StudentNumber}}
                </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell mat-sort-header="name"
                    *matHeaderCellDef
                    translate>
                    Name
                    <filter [data]="tableData"
                        columnName="name"
                        dataType="string"
                        id="nameFilter"
                        class="mat-filter"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let student">
                    {{student.formattedName(generalPreferences)}}
                </mat-cell>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
                <mat-header-cell
                    *matHeaderCellDef
                    translate>
                    <!-- Deliberately left blank -->
                </mat-header-cell>
                <mat-cell *matCellDef="let student; let i = index;">
                    <a [ngStyle]="{'color': getDisabled() || disableStudents ? 'lightgrey' : '', 'cursor': getDisabled() || disableStudents ? '' : 'pointer'}"
                        (click)="deleteStudent(student)">
                        Delete
                    </a>
                </mat-cell>
            </ng-container>

            <!-- Row Definitions -->
            <mat-header-row *matHeaderRowDef="['name', 'studentNumber', 'actions']"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['name', 'studentNumber', 'actions'];"
                matRipple></mat-row>
        </mat-table>
    </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left">
		<tyl-button image="Add.png"
            disabledImage="Add Disabled.png"
			label="Change Students"
			*ngIf="!disableStudents"
            [disabled]="getDisabled()"
			(clickEvent)="changeStudents()"></tyl-button>
	</div>

	<!-- Right -->
	<div class="flex-footer-right">
		<error-prompt [errorList]="errors"></error-prompt>
		<tyl-button image="save black.png"
			*ngIf="!viewMode"
			label="Save"
			(clickEvent)="save()"></tyl-button>
		<tyl-button image="Cancel.png"
			[label]="!viewMode ? 'Cancel' : 'Close'"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>

<!-- Scope Radio Template -->
<ng-template #scopeRadioTemplate let-value="value">
	<div *ngIf="value == 'Public within School'">
		Available to&nbsp;
        <a *ngIf="getDisabled()"
            style="color: grey;">
            Selected Students
        </a>
		<a *ngIf="!getDisabled()"
            (click)="selectedSitesClick()"
			#selectedSitesLink>
			Selected Sites
		</a>
	</div>
</ng-template>
